import React from 'react'
import { Navigate } from 'react-router-dom'

const Updates = React.lazy(() => import('../pages/Support/Updates'))
const Clients = React.lazy(() => import('../pages/Support/Clients'))
const Versions = React.lazy(() => import('../pages/Support/Versions'))
const Users = React.lazy(() => import('../pages/Support/Users'))
const Companies = React.lazy(() => import('../pages/Support/Companies'))

export const getSupportRoutes = (supportLoggedIn) => {
  const gate = (element) => (supportLoggedIn ? element : <Navigate to="/support-login" replace />)
  return [
    { path: '/support/companies', element: gate(<Companies />) },
    { path: '/support/updates', element: gate(<Updates />) },
    { path: '/support/clients', element: gate(<Clients />) },
    { path: '/support/versions', element: gate(<Versions />) },
    { path: '/support/users', element: gate(<Users />) }
  ]
}
